import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { ReceiptHistoryItem } from "../services/invoicingApi";

interface ReceiptHistoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invoiceNumber?: string;
  isLoading?: boolean;
  items: ReceiptHistoryItem[];
}

export const ReceiptHistoryDialog = ({
  open,
  onOpenChange,
  invoiceNumber,
  isLoading = false,
  items,
}: ReceiptHistoryDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Receipt History</DialogTitle>
          <DialogDescription>
            Chronological receipt print events for {invoiceNumber ?? "selected invoice"}.
          </DialogDescription>
        </DialogHeader>

        <div className="max-h-[55vh] overflow-y-auto rounded-lg border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Receipt #</TableHead>
                <TableHead>Printed At</TableHead>
                <TableHead>Printed By</TableHead>
                <TableHead>Count</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Reason</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={6} className="text-center text-muted-foreground">
                    Loading receipt history...
                  </TableCell>
                </TableRow>
              )}
              {!isLoading && items.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.receiptNumber}</TableCell>
                  <TableCell>{new Date(item.printedAt).toLocaleString()}</TableCell>
                  <TableCell>{item.printedByUserName}</TableCell>
                  <TableCell>{item.printCount}</TableCell>
                  <TableCell>{item.isReprint ? "Reprint" : "First print"}</TableCell>
                  <TableCell>{item.reprintReason || "-"}</TableCell>
                </TableRow>
              ))}
              {!isLoading && !items.length && (
                <TableRow>
                  <TableCell colSpan={6} className="text-center text-muted-foreground">
                    No receipt history found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
